import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { cx } from 'class-variance-authority';
import type { RichTranslationValues } from 'next-intl';
import type { ReactNode } from 'react';
import type { MessageKey } from 'types/LocaleMessageKey';

import RichText from '../RichText';

// List item marker
type MarkerType = 'disc' | 'circle';

const MARKER: {
  [x in MarkerType]: {
    classNames: string;
  };
} = {
  disc: { classNames: 'list-disc' },
  circle: { classNames: 'list-circle' },
};

interface LegalListItemProps {
  readonly marker?: MarkerType;
  readonly tx?: MessageKey;
  readonly children?: ReactNode;
  readonly className?: string;
  readonly values?: RichTranslationValues;
}

const LegalListItem = ({
  marker = 'disc',
  tx: text,
  children,
  className,
  values,
}: LegalListItemProps) => {
  const { classNames } = MARKER[marker];
  const copy = values ? (
    <RichText messageKey={text!} tValues={values} />
  ) : (
    <RichText messageKey={text!} />
  );

  return (
    <Typography Element="li" className={cx('ml-4 pl-4', classNames, className)}>
      {copy}

      {/* Reset Typography for nested children */}
      {children && <Typography Element="div">{children}</Typography>}
    </Typography>
  );
};

export default LegalListItem;
